import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueFlashMessage from 'vue-flash-message'
import VueResource from 'vue-resource'
import firebase from 'firebase'
import Notifications from 'vue-notification'
import InfiniteLoading from 'vue-infinite-loading'
import VTooltip from 'v-tooltip'
import JsonCSV from 'vue-json-csv'

// import VueAnalytics from 'vue-analytics'
import './filters'

Vue.config.productionTip = false

Vue.component('downloadCsv', JsonCSV)
Vue.use(VTooltip)
Vue.use(VueResource)
Vue.use(VueFlashMessage)
Vue.use(Notifications)
Vue.use(InfiniteLoading, { /* options */ })

/* Vue.use(VueAnalytics, {
  id: 'UA-113149626-7',
  router
}) */

var config = {
  apiKey: 'AIzaSyDQ_tRMsUMEoj-w9gxdn2xUCeXKaLCnNIo',
  authDomain: 'mvp-framework-81e77.firebaseapp.com',
  databaseURL: 'https://mvp-framework-81e77.firebaseio.com',
  projectId: 'mvp-framework-81e77',
  storageBucket: 'mvp-framework-81e77.appspot.com',
  messagingSenderId: '879766796860'
}

if (process.env.NODE_ENV === 'production') {
  window.console.clear()
  config = {
    apiKey: 'AIzaSyB0GA4KydGe5PbtLjMDJpoxYstvBWVDLOU',
    authDomain: 'auth.orbitly.io',
    databaseURL: 'https://orca-data-enrichment.firebaseio.com',
    projectId: 'orca-data-enrichment',
    storageBucket: 'orca-data-enrichment.appspot.com',
    messagingSenderId: '1092113063439'
  }
}

firebase.initializeApp(config)

if (store.state.user.authenticated === true) {
  var token = store.state.user.data.access_token
  Vue.http.headers.common['Authorization'] = 'Bearer ' + token
} else {
  Vue.http.headers.common['Authorization'] = ''
}

firebase.auth().onAuthStateChanged(() => {
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
})
